export enum BackendRegistationStatus {
    /**
     * None.
     */
    None = 0,

    /**
     * Indicates the user is filling the registration data.
     */
    Filling,

    /**
     * Indicates the user has filled the registration data and
     * the registration is waiting for automatic verification by Rocket.
     */
    AwaitingAutomaticVerification,

    /**
     * Indicates that a request has been sent to Rocket system to validate,
     * but the response was not received yet.
     */
    AwaitingAutomaticVerificationResponse,

    /**
     * Indicates a registration should be validated manually (a user from the registration
     * team should approve or reject the registration, providing details regarding the fields
     * with errors).
     */
    AwaitingManualVerification,

    /**
     * Indicates a registration is waiting for SINACOR integration and validation.
     */
    AwaitingSinacorIntegration,

    /**
     * Indicates a registration is waiting for TD integration and validation.
     */
    AwaitingTDIntegration,

    /**
     * Indicates a registration is waiting for TD integration response.
     */
    AwaitingTDIntegrationResponse,

    /**
     * Indicates a registration is waiting for B3 integration and validation.
     */
    AwaitingB3Integration,

    /**
     * Indicates a registration is waiting for B3 integration response.
     */
    AwaitingB3IntegrationResponse,

    /**
     * Indicates a registration is waiting for CETIP integration and validation.
     */
    AwaitingCETIPIntegration,

    /**
     * Indicates a registration is waiting for CETIP integration response.
     */
    AwaitingCETIPIntegrationResponse,

    /**
     * Indicates a registration process which has no expectation to evolve,
     * canceled by the registration team.
     */
    Canceled,

    /**
     * Indicates there is a internal issue with the registration process,
     * verified by any integrated system (SINACOR, B3, CETIP)
     */
    InternalIssues,

    /**
     * Indicates there is a external issue with the registration process,
     * meaning the customer should update the registration fields with error.
     */
    ExternalIssues,

    /**
     * Indicates that there hasn't been any integration with SINACOR by
     * the period of two years.
     */
    Expired,

    /**
     * Indicates a registration process has been completed successfully.
     */
    Ok,

    /**
     * Indicates a registration should be validated manually by complice (a user from the registration
     * team should approve or reject the registration, providing details regarding the fields
     * with errors).
     */
    AwaitingManualVerificationComplice,
    
    PreExpired,

    AwaitingManualRestrictiveSantanderListVerification,

    AwaitingSendSanctionList,

    AwaitingResponseSanctionList,

    AwaitingManualSanctionListVerification,

    BlockdBycompliance
}